import React, { useEffect, useRef } from "react";
import ReactPlayer from "react-player";
import { useParams } from "react-router-dom";

export default function VideoPlayer() {
  const { id } = useParams();
  const playerRef = useRef(null);

  // Function to handle key press events
  const handleKeyPress = (event) => {
    if (event.key === "s") {
      const player = playerRef.current.getInternalPlayer();
      if (player && player.getVolume && player.setVolume) {
        const currentVolume = player.getVolume();
        const newVolume = Math.max(currentVolume - 10, 0);
        player.setVolume(newVolume);
        console.log(`Volume decreased to ${newVolume}`);
      }
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  return (
    <div className="w-full h-full">
      <div className="w-full h-full">
      <ReactPlayer
        url={`https://www.youtube.com/watch?v=${id}`}
        controls={true}
        playing={true}
        width="100%"
        height="100%"
        ref={playerRef}
        id="video-iframe"
      />
      </div>
    </div>
  );
}
